import { render, staticRenderFns } from "./DelegatingOrganizationsModal.vue?vue&type=template&id=55af5606&scoped=true"
import script from "./DelegatingOrganizationsModal.vue?vue&type=script&lang=js"
export * from "./DelegatingOrganizationsModal.vue?vue&type=script&lang=js"
import style0 from "./DelegatingOrganizationsModal.vue?vue&type=style&index=0&id=55af5606&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55af5606",
  null
  
)

export default component.exports